import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { lastValueFrom, map, of } from 'rxjs';
import { LocalStorageKeys } from 'src/app/configs/local-storage-keys-config';
import { environment } from 'src/environments/environment';
import {
  CustomResultOfGetCurrentClientDataDto,
  GetCurrentClientDataDto,
} from '../api/models';
import { CustomerDomainsService } from '../api/services';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  //#region prop
  private configUrl = environment.configurationPath;
  configDone: boolean = false;
  config = signal<AppConfiguration>({});
  static config: AppConfiguration = {};
  clientData = signal<GetCurrentClientDataDto>({});
  //#endregion

  constructor(private http: HttpClient) {}

  async getConfig(): Promise<any> {
    const config: AppConfiguration = await lastValueFrom(
      this.http.get(this.configUrl)
    );
    AppConfigService.config.serverStateApiUrl = config.serverStateApiUrl;
    AppConfigService.config.serverStateToken = config.serverStateToken;
    const localApiUrl: string = localStorage.getItem(LocalStorageKeys.apiUrl);
    // if (!config?.production && localApiUrl) config.apiUrl = localApiUrl;
    
    if (localApiUrl) config.apiUrl = localApiUrl;
    else config.apiUrl = await this.getAvailableApiUrl(config.apiUrls, 0);
    this.config.set(config);
    this.configDone = true;
    AppConfigService.config = config;
    return config;
  }

  async getAvailableApiUrl(apiUrls: string[], index: number) {
    try {
      if (index + 1 == apiUrls?.length) this.configDone = true;
      const clientData = await lastValueFrom(
        this.http
          .get(
            apiUrls[index] +
              CustomerDomainsService.CustomerDomainsGetCurrentClientDataPath
          )
          .pipe(map((res: CustomResultOfGetCurrentClientDataDto) => res.data))
      );
      this.clientData.set(clientData);
      return lastValueFrom(of(apiUrls[index]));
    } catch (error) {
      if (apiUrls?.length > index + 1)
        return await this.getAvailableApiUrl(apiUrls, index + 1);
    }
  }
}

export type AppConfiguration = {
  production?: boolean;
  apiUrl?: string;
  apiUrls?: string[];
  appUrl?: string;
  notificationSocketUrl?: string;
  gisApiUrl?: string;
  gisStyleUrl?: string;
  gisStyleDarkUrl?: string;
  useMapIr?: boolean;
  mapIrXApiKey?: string;
  mapIrStyleUrl?: string;
  mapIrStyleDarkUrl?: string;
  clockUpdateDelayInMinutes?: number;
  origin?: string;
  showTicketing?: boolean;
  ticketingUrl?: string;
  smartSmsGuideUrl?: string;
  webServiceGuideUrl?: string;
  serverStateApiUrl?: string;
  serverStateToken?: string;
  baseRocketChatUrl?: string;
  rocketChatLiveChatUrl?: string;
  kibanaDashboard?: string;
  isShowDocumentationBtn?: boolean;
};
